// import React, { useState, useRef } from "react";
// import "../styles/healthScoreCard.css";

// import BloodPressureIcon from "../assets/vitals/Bp.svg";
// import HeartRateIcon from "../assets/vitals/Heartrate.svg";
// import OxygenIcon from "../assets/vitals/spo2.svg";
// import RiskIcon from "../assets/vitals/risk.svg";
// import ECGIcon from "../assets/vitals/Ecg.svg";
// import HeartSoundIcon from "../assets/vitals/heartsound.svg";
// import LungSoundIcon from "../assets/vitals/lungsound.svg";

// export default function HealthScoreCard({ data }) {
//   const [open, setOpen] = useState(false);
//   const scrollRef = useRef(null);
//   const [isDown, setIsDown] = useState(false);
//   const [startX, setStartX] = useState(0);
//   const [scrollLeft, setScrollLeft] = useState(0);

//   // --- Safe helper ---
//   const safe = (value, fallback = "Data Not Available") => {
//     return value === undefined || value === null || value === "" ? fallback : value;
//   };

//   // --- Scroll handlers ---
//   const handleMouseDown = (e) => {
//     if (!scrollRef.current) return;
//     setIsDown(true);
//     setStartX(e.pageX - scrollRef.current.offsetLeft);
//     setScrollLeft(scrollRef.current.scrollLeft);
//   };
//   const handleMouseLeave = () => setIsDown(false);
//   const handleMouseUp = () => setIsDown(false);
//   const handleMouseMove = (e) => {
//     if (!isDown || !scrollRef.current) return;
//     e.preventDefault();
//     const x = e.pageX - scrollRef.current.offsetLeft;
//     const walk = (x - startX) * 1.5;
//     scrollRef.current.scrollLeft = scrollLeft - walk;
//   };

//   // --- derive values from data (use safe fallback) ---
//   const health = data?.health_metrics || {};
//   const rawHealthScore = health?.health_score;
//   const healthScore = Number.isFinite(rawHealthScore) ? Math.round(rawHealthScore) : safe(rawHealthScore, "Data Not Available");
//   const healthLabel = safe(health?.health_label, "Data Not Available");
//   const overallSummary = safe(data?.overallSummary, "Data Not Available");

//   // Metric values (use numeric if present, otherwise fallback)
    
    


//     const riskScore = Number.isFinite(health?.risk?.score) ? health.risk.score : null;
//     const riskRange = Number.isFinite(health?.risk?.label) ? health.risk.label : null;


//     const ECGScore = Number.isFinite(health?.ecg?.score) ? health.ecg.score : null;
//     const ECGRange = Number.isFinite(health?.ecg?.label) ? health.ecg.label : null;

//     const bpScore = Number.isFinite(health?.bp?.score) ? health.bp.score : null;
//     const bpRange = Number.isFinite(health?.bp?.label) ? health.bp.label : null;

//     const hrScore = Number.isFinite(health?.heart_rate?.score) ? health.heart_rate.score : null;
//     const hrRange = Number.isFinite(health?.heart_rate?.label) ? health.heart_rate.label : null;

//     const spo2Score = Number.isFinite(health?.spo2?.score) ? health.spo2.score : null;
//     const spo2Range = Number.isFinite(health?.spo2?.label) ? health.spo2.label : null;


//     const heartSoundScore = Number.isFinite(health?.heartSound?.score) ? health.heartSound.score : null;
//     const heartSoundRange = Number.isFinite(health?.heartSound?.label) ? health.heartSound.label : null;


//     const lungSoundScore = Number.isFinite(health?.heartSound?.score) ? health.heartSound.score : null;
//     const lungSoundRange = Number.isFinite(health?.heartSound?.label) ? health.heartSound.label : null;
//   // Build metrics array from API values (keep icon, title, range)
//   const metrics = [
//     {
//       title: "Risk Assesment",
//       value: riskScore,
//       range: riskRange,
//       icon: RiskIcon,
//     },
//     {
//       title: "ECG",
//       value: ECGScore,
//       range: ECGRange,
//       icon: ECGIcon,
//     },
//     {
//       title: "Blood Pressure",
//       value: bpScore,
//       range: bpRange,
//       icon: BloodPressureIcon,
//     },
//     {
//       title: "Heart Rate",
//       value: hrScore,
//       range: hrRange,
//       icon: HeartRateIcon,
//     },
//     {
//       title: "Oxygen Level",
//       value: spo2Score,
//       range: spo2Range,
//       icon: OxygenIcon,
//     },
//     {
//       title: "Heart Sound",
//       value: heartSoundScore,
//       range: heartSoundRange,
//       icon: HeartSoundIcon,
//     },
//     {
//       title: "Lung Sound",
//       value: lungSoundScore,
//       range: lungSoundRange,
//       icon: LungSoundIcon,
//     }
//   ];

//   const getBarColor = (value) => {
//     if (!Number.isFinite(value)) return "grey"; // "Data Not Available"
//     if (value >= 80) return "green";
//     else if (value >= 50) return "yellow";
//     else return "red";
//   };

//   // Helper to render metric value with fallback
//   const renderMetricValue = (metric) => {
//     const v = metric.value;
//     if (!Number.isFinite(v)) return "Data Not Available";
//     if (metric.title === "Oxygen Level") return `${v}%`;
//     return `${v}/100`;
//   };

//   // Helper for bar width (clamp 0..100)
//   const barWidth = (value) => {
//     if (!Number.isFinite(value)) return "0%";
//     const num = Math.max(0, Math.min(100, value));
//     return `${num}%`;
//   };

//   return (
//     <>
//       {/* MAIN CARD */}
//       <div className="top-card" onClick={() => setOpen(true)}>
//         <h3 className="title">Health Score</h3>

//         <div className="health-score-box">
//           <div className="score-number">
//             {typeof healthScore === "number" ? healthScore : healthScore}
//           </div>
//           <div className="vertical-divider"></div>
//           <div className="score-status">{healthLabel}</div>
//         </div>
//       </div>

//       {/* POPUP */}
//       {open && (
//         <div className="popup-overlay" onClick={() => setOpen(false)}>
//           <div
//             className="popup-container popup-animate"
//             onClick={(e) => e.stopPropagation()}
//           >
//             {/* HEADER */}
//             <div className="popup-header">
//               <h2>Overall Health Score</h2>
//               <button className="close-btn" onClick={() => setOpen(false)}>
//                 ✕
//               </button>
//             </div>

//             {/* SUMMARY */}
//             <div className="summary-box">
//               <div className="big-score">
//                 {typeof healthScore === "number" ? `${healthScore}/100` : healthScore}{" "}
//                 <span className={`tag ${healthLabel === "Data Not Available" ? "unknown" : "excellent"}`}>
//                   {healthLabel}
//                 </span>
//               </div>

//               <p
//                 className="summary-text"
//                 style={{ whiteSpace: "pre-line" }}
//               >
//                 {overallSummary}
//               </p>
//             </div>

//             {/* HORIZONTAL SCROLL */}
//             <div
//               className="h-scroll"
//               ref={scrollRef}
//               onMouseDown={handleMouseDown}
//               onMouseLeave={handleMouseLeave}
//               onMouseUp={handleMouseUp}
//               onMouseMove={handleMouseMove}
//             >
//               {metrics.map((metric, i) => (
//                 <div className="metric-card wide" key={i}>
//                   <div className="metric-row">
//                     <img src={metric.icon} alt={metric.title} className="metric-icon" />
//                     <h4 className="metric-title">{metric.title}</h4>
//                     <div className={`metric-value ${getBarColor(metric.value)}`}>
//                       {renderMetricValue(metric)}
//                     </div>
//                   </div>

//                   <div className="metric-bar">
//                     <div
//                       className={`bar-fill ${getBarColor(metric.value)}`}
//                       style={{ width: barWidth(metric.value) }}
//                     ></div>
//                   </div>

//                   <p className="range">{metric.range}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }























// import React, { useState, useRef } from "react";
// import "../styles/healthScoreCard.css";

// import BloodPressureIcon from "../assets/vitals/Bp.svg";
// import HeartRateIcon from "../assets/vitals/Heartrate.svg";
// import OxygenIcon from "../assets/vitals/spo2.svg";
// import RiskIcon from "../assets/vitals/risk.svg";
// import ECGIcon from "../assets/vitals/Ecg.svg";
// import HeartSoundIcon from "../assets/vitals/heartsound.svg";
// import LungSoundIcon from "../assets/vitals/lungsound.svg";

// export default function HealthScoreCard({ data }) {
//   const [open, setOpen] = useState(false);
//   const scrollRef = useRef(null);
//   const [isDown, setIsDown] = useState(false);
//   const [startX, setStartX] = useState(0);
//   const [scrollLeft, setScrollLeft] = useState(0);

//   // --- Safe helper ---
//   const safe = (value, fallback = "Data Not Available") => {
//     return value === undefined || value === null || value === "" ? fallback : value;
//   };

//   // --- Scroll handlers ---
//   const handleMouseDown = (e) => {
//     if (!scrollRef.current) return;
//     setIsDown(true);
//     setStartX(e.pageX - scrollRef.current.offsetLeft);
//     setScrollLeft(scrollRef.current.scrollLeft);
//   };
//   const handleMouseLeave = () => setIsDown(false);
//   const handleMouseUp = () => setIsDown(false);
//   const handleMouseMove = (e) => {
//     if (!isDown || !scrollRef.current) return;
//     e.preventDefault();
//     const x = e.pageX - scrollRef.current.offsetLeft;
//     const walk = (x - startX) * 1.5;
//     scrollRef.current.scrollLeft = scrollLeft - walk;
//   };

//   // --- Data Extraction ---
//   const health = data?.health_metrics || {};
//   const rawHealthScore = health?.health_score;
//   const healthScore = Number.isFinite(rawHealthScore) ? Math.round(rawHealthScore) : safe(rawHealthScore, "N/A");
//   const healthLabel = safe(health?.health_label, "Data Not Available");
//   const overallSummary = safe(data?.overallSummary, "Data Not Available");

//   // Metrics extraction
//   const riskScore = Number.isFinite(health?.risk?.score) ? health.risk.score : null;
//   const riskRange = Number.isFinite(health?.risk?.label) ? health.risk.label : null;

//   const ECGScore = Number.isFinite(health?.ecg?.score) ? health.ecg.score : null;
//   const ECGRange = Number.isFinite(health?.ecg?.label) ? health.ecg.label : null;

//   const bpScore = Number.isFinite(health?.bp?.score) ? health.bp.score : null;
//   const bpRange = Number.isFinite(health?.bp?.label) ? health.bp.label : null;

//   const hrScore = Number.isFinite(health?.heart_rate?.score) ? health.heart_rate.score : null;
//   const hrRange = Number.isFinite(health?.heart_rate?.label) ? health.heart_rate.label : null;

//   const spo2Score = Number.isFinite(health?.spo2?.score) ? health.spo2.score : null;
//   const spo2Range = Number.isFinite(health?.spo2?.label) ? health.spo2.label : null;

//   const heartSoundScore = Number.isFinite(health?.heartSound?.score) ? health.heartSound.score : null;
//   const heartSoundRange = Number.isFinite(health?.heartSound?.label) ? health.heartSound.label : null;

//   const lungSoundScore = Number.isFinite(health?.heartSound?.score) ? health.heartSound.score : null;
//   const lungSoundRange = Number.isFinite(health?.heartSound?.label) ? health.heartSound.label : null;

//   const metrics = [
//     { title: "Risk Assesment", value: riskScore, range: riskRange, icon: RiskIcon },
//     { title: "ECG", value: ECGScore, range: ECGRange, icon: ECGIcon },
//     { title: "Blood Pressure", value: bpScore, range: bpRange, icon: BloodPressureIcon },
//     { title: "Heart Rate", value: hrScore, range: hrRange, icon: HeartRateIcon },
//     { title: "Oxygen Level", value: spo2Score, range: spo2Range, icon: OxygenIcon },
//     { title: "Heart Sound", value: heartSoundScore, range: heartSoundRange, icon: HeartSoundIcon },
//     { title: "Lung Sound", value: lungSoundScore, range: lungSoundRange, icon: LungSoundIcon }
//   ];

//   // --- NEW LOGIC: 1-40 Red, 40-75 Orange, 75-100 Green ---
//   const getTheme = (score) => {
//     if (typeof score !== 'number') return { color: "grey", bg: "#f5f5f5", label: "N/A" };
    
//     if (score >= 75) {
//       return { color: "#28b463", bg: "#d6f7e0", labelColor: "#28b463" }; // Green
//     } else if (score >= 40) {
//       return { color: "#f2994a", bg: "#fde6cf", labelColor: "#e67e22" }; // Orange
//     } else {
//       return { color: "#ff4d4f", bg: "#ffe5e7", labelColor: "#ff4d4f" }; // Red
//     }
//   };

//   // Styles for the donut chart and right box
//   const theme = getTheme(healthScore);
//   const percentage = typeof healthScore === 'number' ? healthScore : 0;
  
//   // Inline style for dynamic donut gradient
//   const donutStyle = {
//     background: `conic-gradient(${theme.color} ${percentage * 3.6}deg, #f0f0f0 0deg)`
//   };

//   // Helper for metric bars inside popup (keeping your logic or syncing with new logic)
//   const getBarColor = (value) => {
//     if (!Number.isFinite(value)) return "grey";
//     if (value >= 75) return "green";
//     else if (value >= 40) return "yellow"; // Map yellow class to orange visually in CSS if desired
//     else return "red";
//   };

//   const barWidth = (value) => {
//     if (!Number.isFinite(value)) return "0%";
//     const num = Math.max(0, Math.min(100, value));
//     return `${num}%`;
//   };

//   const renderMetricValue = (metric) => {
//     const v = metric.value;
//     if (!Number.isFinite(v)) return "N/A";
//     if (metric.title === "Oxygen Level") return `${v}%`;
//     return `${v}/100`;
//   };

//   return (
//     <>
//       {/* MAIN CARD - NEW DESIGN */}
//       <div className="top-card" onClick={() => setOpen(true)}>
//         <h3 className="title">Health Score</h3>

//         <div className="new-health-layout">
//           {/* Left Side: Donut Chart */}
//           <div className="donut-section">
//             <div className="donut-chart" style={donutStyle}>
//               <div className="donut-hole">
//                 <span className="donut-text" style={{ color: theme.color }}>
//                   {healthScore}
//                 </span>
//               </div>
//             </div>
//             {/* Optional data incomplete text shown in image */}
//             {/* <p className="sub-text">Data Incomplete</p> */}
//           </div>

//           {/* Right Side: Colored Box */}
//           <div className="status-box-right" style={{ backgroundColor: theme.bg }}>
//              <div className="status-pill">
//                <span className="status-pill-text" style={{ color: theme.labelColor }}>
//                  {healthLabel || "Unknown"}
//                </span>
//              </div>
//           </div>
//         </div>
//       </div>

//       {/* POPUP */}
//       {open && (
//         <div className="popup-overlay" onClick={() => setOpen(false)}>
//           <div className="popup-container popup-animate" onClick={(e) => e.stopPropagation()}>
//             {/* HEADER */}
//             <div className="popup-header">
//               <h2>Overall Health Score</h2>
//               <button className="close-btn" onClick={() => setOpen(false)}>✕</button>
//             </div>

//             {/* SUMMARY */}
//             <div className="summary-box">
//               <div className="big-score" style={{ color: theme.color }}>
//                 {typeof healthScore === "number" ? `${healthScore}/100` : healthScore}{" "}
//                 <span className="tag" style={{ backgroundColor: theme.bg, color: theme.color }}>
//                   {healthLabel}
//                 </span>
//               </div>
//               <p className="summary-text" style={{ whiteSpace: "pre-line" }}>
//                 {overallSummary}
//               </p>
//             </div>

//             {/* SCROLL METRICS */}
//             <div
//               className="h-scroll"
//               ref={scrollRef}
//               onMouseDown={handleMouseDown}
//               onMouseLeave={handleMouseLeave}
//               onMouseUp={handleMouseUp}
//               onMouseMove={handleMouseMove}
//             >
//               {metrics.map((metric, i) => (
//                 <div className="metric-card wide" key={i}>
//                   <div className="metric-row">
//                     <img src={metric.icon} alt={metric.title} className="metric-icon" />
//                     <h4 className="metric-title">{metric.title}</h4>
//                     <div className={`metric-value ${getBarColor(metric.value)}`}>
//                       {renderMetricValue(metric)}
//                     </div>
//                   </div>
//                   <div className="metric-bar">
//                     <div
//                       className={`bar-fill ${getBarColor(metric.value)}`}
//                       style={{ width: barWidth(metric.value) }}
//                     ></div>
//                   </div>
//                   <p className="range">{metric.range}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }







import React, { useState, useRef } from "react";
import "../styles/healthScoreCard.css";

import BloodPressureIcon from "../assets/vitals/Bp.svg";
import HeartRateIcon from "../assets/vitals/Heartrate.svg";
import OxygenIcon from "../assets/vitals/spo2.svg";
import RiskIcon from "../assets/vitals/risk.svg";
import ECGIcon from "../assets/vitals/Ecg.svg";
import HeartSoundIcon from "../assets/vitals/heartsound.svg";
import LungSoundIcon from "../assets/vitals/lungsound.svg";

export default function HealthScoreCard({ data, patientInfo }) {
  const [open, setOpen] = useState(false);
  const scrollRef = useRef(null);
  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  // --- Safe helper ---
  const safe = (value, fallback = "Data Not Available") => {
    return value === undefined || value === null || value === "" ? fallback : value;
  };

  // --- Scroll handlers ---
  const handleMouseDown = (e) => {
    if (!scrollRef.current) return;
    setIsDown(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };
  const handleMouseLeave = () => setIsDown(false);
  const handleMouseUp = () => setIsDown(false);
  const handleMouseMove = (e) => {
    if (!isDown || !scrollRef.current) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 1.5;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  // --- Data Extraction ---
  const health = data?.health_metrics || {};
  const rawHealthScore = health?.health_score;
  const healthScore = Number.isFinite(rawHealthScore) ? Math.round(rawHealthScore) : safe(rawHealthScore, "N/A");
  const healthLabel = safe(health?.health_label, "Data Not Available");
  const overallSummary = safe(data?.overallSummary, "Data Not Available");

  // Metrics extraction
  const riskScore = Number.isFinite(health?.risk?.score) ? health.risk.score : null;
  const riskRange = Number.isFinite(health?.risk?.label) ? health.risk.label : null;

  const ECGScore = health?.ecg?.score ?? null;
  const ECGRange = health?.ecg?.label ?? null;

  const bpScore = health?.bp?.score ?? null;
  const bpRange = health?.bp?.label ?? null;

  const hrScore = health?.heart_rate?.score ?? null;
  const hrRange = health?.heart_rate?.label ?? null;

  const spo2Score = health?.spo2?.score ?? null;
  const spo2Range = health?.spo2?.label ?? null;

  const heartSoundScore = health?.heart_sound?.score ?? null;
  const heartSoundRange = health?.heart_sound?.label ?? null;

  const lungSoundScore = health?.lung_sound?.score ?? null;
  const lungSoundRange = health?.lung_sound?.label ?? null;

  const metrics = [
    { title: "ECG", value: ECGScore, range: ECGRange, icon: ECGIcon },
    { title: "Blood Pressure", value: bpScore, range: bpRange, icon: BloodPressureIcon },
    { title: "Heart Rate", value: hrScore, range: hrRange, icon: HeartRateIcon },
    { title: "Oxygen Level", value: spo2Score, range: spo2Range, icon: OxygenIcon },
    { title: "Heart Sound", value: heartSoundScore, range: heartSoundRange, icon: HeartSoundIcon },
    { title: "Lung Sound", value: lungSoundScore, range: lungSoundRange, icon: LungSoundIcon }
  ];

  // --- LOGIC: Check for incomplete data ---
  // Returns TRUE if either Heart Sound OR Lung Sound is missing (null)
  const isDataIncomplete = heartSoundScore === null || lungSoundScore === null;

  // --- NEW LOGIC: 1-40 Red, 40-75 Orange, 75-100 Green ---
  const getTheme = (score) => {
    if (typeof score !== 'number') return { color: "grey", bg: "#f5f5f5", label: "N/A" };
    
    if (score >= 75) {
      return { color: "#28b463", bg: "#d6f7e0", labelColor: "#28b463" }; // Green
    } else if (score >= 40) {
      return { color: "#f2994a", bg: "#fde6cf", labelColor: "#e67e22" }; // Orange
    } else {
      return { color: "#ff4d4f", bg: "#ffe5e7", labelColor: "#ff4d4f" }; // Red
    }
  };

  const theme = getTheme(healthScore);
  const percentage = typeof healthScore === 'number' ? healthScore : 0;
  
  const donutStyle = {
    background: `conic-gradient(${theme.color} ${percentage * 3.6}deg, #f0f0f0 0deg)`
  };

  const getBarColor = (value) => {
    if (!Number.isFinite(value)) return "grey";
    if (value >= 75) return "green";
    else if (value >= 40) return "yellow"; 
    else return "red";
  };

  const barWidth = (value) => {
    if (!Number.isFinite(value)) return "0%";
    const num = Math.max(0, Math.min(100, value));
    return `${num}%`;
  };

  const renderMetricValue = (metric) => {
    const v = metric.value;
    if (!Number.isFinite(v)) return "N/A";
    if (metric.title === "Oxygen Level") return `${v}%`;
    return `${v}/100`;
  };

  return (
    <>
      {/* MAIN CARD - NEW DESIGN */}
      <div className="top-card" onClick={() => setOpen(true)}>
        <h3 className="title">Health Score</h3>

        <div className="new-health-layout">
          {/* Left Side: Donut Chart */}
          <div className="donut-section">
            <div className="donut-chart" style={donutStyle}>
              <div className="donut-hole">
                <span className="donut-text" style={{ color: theme.color }}>
                  {healthScore}
                </span>
              </div>
            </div>
            
            {/* CONDITIONAL RENDERING: Only show if heart or lung sound is missing */}
            {isDataIncomplete && (
              <div className="incomplete-container">
                 {/* Simple SVG Exclamation Icon */}
                 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '4px', marginTop: '1px'}}>
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#777"/>
                    <path d="M12 8V13" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 16H12.01" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                 </svg>
                 <p className="sub-text">Data Incomplete</p>
              </div>
            )}
          </div>

          {/* Right Side: Colored Box */}
          <div className="status-box-right" style={{ backgroundColor: theme.bg }}>
             <div className="status-pill">
               <span className="status-pill-text" style={{ color: theme.labelColor }}>
                 {healthLabel || "Unknown"}
               </span>
             </div>
          </div>
        </div>
      </div>

      {/* POPUP */}
      {open && (
        <div className="popup-overlay" onClick={() => setOpen(false)}>
          <div className="popup-container popup-animate" onClick={(e) => e.stopPropagation()}>
            <div className="popup-header">
              <h2>Overall Health Score</h2>
              <button className="close-btn" onClick={() => setOpen(false)}>✕</button>
            </div>

            <div className="summary-box">
              <div className="big-score" style={{ color: theme.color }}>
                {typeof healthScore === "number" ? `${healthScore}/100` : healthScore}{" "}
                <span className="tag" style={{ backgroundColor: theme.bg, color: theme.color }}>
                  {healthLabel}
                </span>
              </div>
              <p className="summary-text" style={{ whiteSpace: "pre-line" }}>
                {overallSummary}
              </p>
            </div>

            <div
              className="h-scroll"
              ref={scrollRef}
              onMouseDown={handleMouseDown}
              onMouseLeave={handleMouseLeave}
              onMouseUp={handleMouseUp}
              onMouseMove={handleMouseMove}
            >
              {metrics.map((metric, i) => (
                <div className="metric-card wide" key={i}>
                  <div className="metric-row">
                    <img src={metric.icon} alt={metric.title} className="metric-icon" />
                    <h4 className="metric-title">{metric.title}</h4>
                    <div className={`metric-value ${getBarColor(metric.value)}`}>
                      {renderMetricValue(metric)}
                    </div>
                  </div>
                  <div className="metric-bar">
                    <div
                      className={`bar-fill ${getBarColor(metric.value)}`}
                      style={{ width: barWidth(metric.value) }}
                    ></div>
                  </div>
                  <p className="range">{metric.range}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}